// The documentation fee is charged per document at a fixed unit (E180). Admins
// pick a document count from a dropdown and the amount is count × unit; "None"
// (E0) is the default and anything outside the presets uses a Custom input.
export const DOCUMENTATION_FEE_UNIT = 180;
export const DOCUMENTATION_FEE_MAX_COUNT = 3;

// One preset amount per document count, from 0 (None) up to the max.
export const DOCUMENTATION_FEE_PRESETS = Array.from(
  { length: DOCUMENTATION_FEE_MAX_COUNT + 1 },
  (_, count) => count * DOCUMENTATION_FEE_UNIT,
) as readonly number[];

export const isPresetDocumentationFee = (value: number | string): boolean =>
  DOCUMENTATION_FEE_PRESETS.includes(Number(value));

// Dropdown label for a preset amount — just the document multiplier:
// "None", "x1", "x2", "x3". The computed amount is shown in a separate field.
export const documentationFeeOptionLabel = (amount: number): string => {
  const count = amount / DOCUMENTATION_FEE_UNIT;
  return count === 0 ? 'None' : `x${count}`;
};
